/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiBigBoardAdvanceMetricsGet$Any } from '../fn/big-board/api-big-board-advance-metrics-get-any';
import { ApiBigBoardAdvanceMetricsGet$Any$Params } from '../fn/big-board/api-big-board-advance-metrics-get-any';
import { apiBigBoardAdvanceMetricsGet$Json } from '../fn/big-board/api-big-board-advance-metrics-get-json';
import { ApiBigBoardAdvanceMetricsGet$Json$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-full';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-full';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-full-odata-streaming-false';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-full-odata-streaming-false';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-full-odata-streaming-true';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-full-odata-streaming-true';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-minimal';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-minimal';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-none';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-none';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-none-odata-streaming-false';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-none-odata-streaming-false';
import { apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-none-odata-streaming-true';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-metadata-none-odata-streaming-true';
import { apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-streaming-false';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-streaming-false';
import { apiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-streaming-true';
import { ApiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue$Params } from '../fn/big-board/api-big-board-advance-metrics-get-json-odata-streaming-true';
import { apiBigBoardAdvanceMetricsGet$Plain } from '../fn/big-board/api-big-board-advance-metrics-get-plain';
import { ApiBigBoardAdvanceMetricsGet$Plain$Params } from '../fn/big-board/api-big-board-advance-metrics-get-plain';
import { apiBigBoardAdvanceMetricsGet$Xml } from '../fn/big-board/api-big-board-advance-metrics-get-xml';
import { ApiBigBoardAdvanceMetricsGet$Xml$Params } from '../fn/big-board/api-big-board-advance-metrics-get-xml';
import { apiBigBoardOneNumberMetricsGet$Any } from '../fn/big-board/api-big-board-one-number-metrics-get-any';
import { ApiBigBoardOneNumberMetricsGet$Any$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-any';
import { apiBigBoardOneNumberMetricsGet$Json } from '../fn/big-board/api-big-board-one-number-metrics-get-json';
import { ApiBigBoardOneNumberMetricsGet$Json$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-full';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-full';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-full-odata-streaming-false';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-full-odata-streaming-false';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-full-odata-streaming-true';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-full-odata-streaming-true';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-minimal';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-minimal';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-none';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-none';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-none-odata-streaming-false';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-none-odata-streaming-false';
import { apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-none-odata-streaming-true';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-metadata-none-odata-streaming-true';
import { apiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-streaming-false';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-streaming-false';
import { apiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-streaming-true';
import { ApiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-json-odata-streaming-true';
import { apiBigBoardOneNumberMetricsGet$Plain } from '../fn/big-board/api-big-board-one-number-metrics-get-plain';
import { ApiBigBoardOneNumberMetricsGet$Plain$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-plain';
import { apiBigBoardOneNumberMetricsGet$Xml } from '../fn/big-board/api-big-board-one-number-metrics-get-xml';
import { ApiBigBoardOneNumberMetricsGet$Xml$Params } from '../fn/big-board/api-big-board-one-number-metrics-get-xml';
import { BigBoardAdvancedMetricsDtoListResult } from '../models/big-board-advanced-metrics-dto-list-result';
import { BigBoardMetricsDtoListResult } from '../models/big-board-metrics-dto-list-result';

@Injectable({ providedIn: 'root' })
export class BigBoardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiBigBoardOneNumberMetricsGet()` */
  static readonly ApiBigBoardOneNumberMetricsGetPath = '/api/big-board/one-number-metrics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse$Response(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse(params?: ApiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$Json$Response(params?: ApiBigBoardOneNumberMetricsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$Json(params?: ApiBigBoardOneNumberMetricsGet$Json$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$Xml$Response(params?: ApiBigBoardOneNumberMetricsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$Xml(params?: ApiBigBoardOneNumberMetricsGet$Xml$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$Plain$Response(params?: ApiBigBoardOneNumberMetricsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$Plain(params?: ApiBigBoardOneNumberMetricsGet$Plain$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardOneNumberMetricsGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$Any$Response(params?: ApiBigBoardOneNumberMetricsGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardMetricsDtoListResult>> {
    return apiBigBoardOneNumberMetricsGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardOneNumberMetricsGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardOneNumberMetricsGet$Any(params?: ApiBigBoardOneNumberMetricsGet$Any$Params, context?: HttpContext): Observable<BigBoardMetricsDtoListResult> {
    return this.apiBigBoardOneNumberMetricsGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardMetricsDtoListResult>): BigBoardMetricsDtoListResult => r.body)
    );
  }

  /** Path part for operation `apiBigBoardAdvanceMetricsGet()` */
  static readonly ApiBigBoardAdvanceMetricsGetPath = '/api/big-board/advance-metrics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse$Response(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse(params?: ApiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$Json$Response(params?: ApiBigBoardAdvanceMetricsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$Json(params?: ApiBigBoardAdvanceMetricsGet$Json$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$Xml$Response(params?: ApiBigBoardAdvanceMetricsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$Xml(params?: ApiBigBoardAdvanceMetricsGet$Xml$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$Plain$Response(params?: ApiBigBoardAdvanceMetricsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$Plain(params?: ApiBigBoardAdvanceMetricsGet$Plain$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBigBoardAdvanceMetricsGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$Any$Response(params?: ApiBigBoardAdvanceMetricsGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
    return apiBigBoardAdvanceMetricsGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBigBoardAdvanceMetricsGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBigBoardAdvanceMetricsGet$Any(params?: ApiBigBoardAdvanceMetricsGet$Any$Params, context?: HttpContext): Observable<BigBoardAdvancedMetricsDtoListResult> {
    return this.apiBigBoardAdvanceMetricsGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>): BigBoardAdvancedMetricsDtoListResult => r.body)
    );
  }

}
